import PropTypes from 'prop-types'
import React from 'react'
import { Alert } from 'element-react'

// This has been modified to return a copy of the Alert component that accepts
// React elements instead of a string when given that.
const ErrorAlert = ({ error, closable }) =>
    typeof error === 'string' ? (
        <Alert
            showIcon={true}
            className="margin-bottom-small"
            description={error}
            title="Error"
            type="error"
            closable={closable}
        />
    ) : (
        <div className="el-alert el-alert--error margin-bottom-small">
            <i className="el-alert__icon el-icon-circle-cross is-big" />
            <div className="el-alert__content">
                <span className="el-alert__title is-bold">Error</span>
                <p className="el-alert__description">{error}</p>
            </div>
        </div>
    )

ErrorAlert.propTypes = {
    closable: PropTypes.bool,
    closeText: PropTypes.string,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.node,
    ]).isRequired,
    onClose: PropTypes.func,
}

export default ErrorAlert
